/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getListBlocks.defs.js'
export * as $defs from './getListBlocks.defs.js'
